import React, { FC, ReactElement } from 'react';
import cn from 'classnames';
import styles from './ProductPrice.module.scss';
import PricesSize from './types';

export interface RegularPriceProps {
  formattedPrice?: string;
  unformattedPrice?: number;
  hasDiscount?: boolean;
  priceUnits?: ReactElement;
  remark?: string | undefined;
  theme?: string;
  size?: PricesSize;
  isPlusDiscountActive?: boolean;
}

const RegularPrice: FC<RegularPriceProps> = ({
  formattedPrice,
  unformattedPrice,
  hasDiscount,
  priceUnits,
  remark,
  theme,
  size = PricesSize.lg,
  isPlusDiscountActive,
}) => {
  if (!formattedPrice) {
    return null;
  }

  return (
    <div className={cn(styles.priceContainer, styles[`theme-${theme}`], styles[`size-${size}`])}>
      <span
        {...{ content: unformattedPrice }}
        className={cn(styles.regularPrice, {
          [styles.hasDiscount]: hasDiscount,
          [styles.plusDiscountedPrice]: isPlusDiscountActive,
        })}
      >
        {formattedPrice}
        {priceUnits}
        {remark}
      </span>
    </div>
  );
};

export default RegularPrice;
